/**
 *  In order for this function to work on iOS, it needs to be called in a handler
 *  for user gesture
 * */
export async function getBrowserMicPermission(): Promise<PermissionState> {
  // Try Permissions API first (not supported on iOS)
  if (navigator.permissions && navigator.permissions.query) {
    const status = await navigator.permissions.query({
      name: "microphone" as PermissionName,
    });

    return status.state;
  }

  // Fallback: Try to get user media (must be in user gesture on iOS)
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    stream.getTracks().forEach((track) => track.stop());

    return "granted";
  } catch {
    return "denied";
  }
}
